import { cn } from '@lib/cn'
import { ComponentProps } from 'react'

export function Spinner({ className, ...svgProps }: ComponentProps<'svg'>) {
  const strokeWidth = 3
  const r = 16 - strokeWidth
  const C = 2 * r * Math.PI
  const offset = C - (1 / 4) * C
  return (
    <svg
      viewBox="0 0 32 32"
      strokeWidth={strokeWidth}
      fill="none"
      stroke="currentcolor"
      role="img"
      width="1em"
      height="1em"
      className={cn('animate-spin text-3xl duration-500', className)}
      {...svgProps}
    >
      <circle cx={16} cy={16} r={r} opacity={1 / 8} />
      <circle cx={16} cy={16} r={r} strokeDasharray={C} strokeDashoffset={offset} />
    </svg>
  )
}
